/**
 * sentry 错误Error扩展
 */

// ApiError
export class ApiError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "ApiError";
	}
}

// DepositError
export class DepositError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "DepositError";
	}
}

// RockBot
export class CopilotError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "CopilotError";
	}
}

// WithdrawError

export class WithdrawError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "WithdrawError";
	}
}

// statementError
export class StatementError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "StatementError";
	}
}

// 客服Error
export class ContactUsError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "ContactUsError";
	}
}

export class UploadError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "UploadError";
	}
}
